export default "__VITE_ASSET__ZlBHAd_p__"